import DOMPurify from "dompurify";

// Allow the tags/attributes used by our rich editors + policy @-mention chip.
const CONFIG = {
    ALLOWED_TAGS: [
        "p", "br", "strong", "em", "b", "i", "u", "s", "a", "hr",
        "ul", "ol", "li", "blockquote", "code", "pre",
        "h1", "h2", "h3", "h4", "span", "div",
    ],
    ALLOWED_ATTR: [
        "href", "target", "rel", "class",
        "data-policy-id", "data-anchor-id", "contenteditable",
    ],
    ALLOW_DATA_ATTR: false,
};

/** Return a sanitized HTML string safe for dangerouslySetInnerHTML / .innerHTML */
export function sanitizeHtml(html) {
    if (!html) return "";
    return DOMPurify.sanitize(String(html), CONFIG);
}
